module.exports = __webpack_public_path__ + "static/img/企业证书.62a955c7.png";